import theme from 'styles/theme';

export const SNACKBAR_FONT_SETTINGS = {
  fontWeight: `${theme.typography.fontWeightBold} !important`,
  fontSize: '0.7858rem !important',
};
